import { useQuery } from '@tanstack/react-query';
import {
	calculateGamePerformance,
	type GamePerformanceCalculationResult,
} from '../services/gamePerformanceService';

interface UseGamePerformanceParams {
	productNames: string[];
	gameTitles: string[];
	enabled?: boolean;
}

export function useGamePerformance({
	productNames,
	gameTitles,
	enabled = true,
}: UseGamePerformanceParams) {
	return useQuery<GamePerformanceCalculationResult, Error>({
		queryKey: ['gamePerformance', productNames, gameTitles],
		queryFn: () => calculateGamePerformance(productNames, gameTitles),
		enabled: enabled && productNames.length > 0 && gameTitles.length > 0,
		staleTime: 5 * 60 * 1000,
		placeholderData: (previousData) => previousData,
	});
}